<template>
  <div class="z-60">
    <transition name="fade" mode="out-in">
      <div
        v-if="showShare"
        class="fixed left-0 top-0 z-60 h-screen w-screen bg-grey-3"
        @click="exit"
      ></div>
    </transition>

    <div
      class="max-w-screen container fixed left-1/2 top-1/2 z-60 -translate-x-1/2 -translate-y-1/2 scale-0 transform rounded-5xl bg-white p-14 transition-all md:w-screen-2/5"
      :class="{ 'scale-100': showShare }"
    >
      <img
        src="@/assets/svg/cross.svg"
        alt="cross"
        class="absolute right-6 top-6 cursor-pointer"
        @click="exit"
      />
      <!--div v-if="!loading" :style="'background-image: url(\''+ output +'\'); background-size: cover; background-position: center center;'" class="h-64 w-full"></div-->
      <div v-if="!loading" class="h-80 w-full">
        <img v-if="!loading" :src="output" alt="" style="max-height: 20rem" class="mx-auto" />
      </div>
      <Loading v-else center />
      <div class="mt-6 text-sm text-grey-3">{{ $t('share.title') }}</div>
      <div class="mt-4 flex hidden justify-center">
        <div
          v-for="(social, index) in socials"
          v-bind:key="social"
          class="relative h-14 w-14 cursor-pointer rounded-2xl bg-grey-ghost"
          :class="{ 'mr-8': index < socials.length - 1 }"
          @click="share(social)"
        >
          <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
            <img
              :src="require('@/assets/svg/social/' + social[0] + '.svg')"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="mt-4 text-sm">
        <span class="mr-1 hidden text-grey-3">
          {{ $t('wording.or') }}
        </span>
        <a v-if="shareLink && !isGoNative" :href="shareLink" download="my_impact">
          <span class="orange-link">{{ $t('share.save') }}</span>
        </a>
        <a v-else-if="shareLink && isGoNative" :href="shareLink" @click="saveGoNative">
          <span class="orange-link">{{ $t('share.save') }}</span>
        </a>
        <a v-else :href="output" download="my_impact">
          <span class="orange-link">{{ $t('share.save') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/general/Loading.vue'
import html2canvas from 'html2canvas'

export default {
  components: { Loading },

  props: {
    type: {
      type: String,
      default: 'login',
    },
  },
  data() {
    return {
      isGoNative: false,
      output: null,
      loading: false,
      socials: ['facebook', 'instagram', 'email'],
    }
  },
  computed: {
    el() {
      return this.$store.state.general.share
    },
    showShare() {
      return this.$store.state.general.showShare
    },
    shareLink() {
      return this.$store.state.general.shareLink
    },
  },
  mounted() {
    if (navigator.userAgent.indexOf('gonative') > -1) {
      this.isGoNative = true
    }
  },
  watch: {
    async el() {
      this.el.classList.remove('hidden')
      await this.print()
    },
  },
  methods: {
    share(method) {
      // t=document.title;
      switch (method) {
        case 'linkedin':
          window.open(
            'http://www.facebook.com/sharer.php?u=' + '',
            'sharer',
            'toolbar=0,status=0,width=626,height=436'
          )
          break;
        case 'instagram':
          window.open(
            'http://www.facebook.com/sharer.php?u=' + '',
            'sharer',
            'toolbar=0,status=0,width=626,height=436'
          )
          break;
        case 'email':
          window.open('mailto:')
          break;
      }
    },

    saveGoNative() {
      //eslint-disable-next-line
      gonative.share.downloadImage({ url: this.shareLink })
    },

    async print() {
      this.loading = true
      const options = {
        type: 'dataURL',
        backgroundColor: null,
      }
      const canvas = await html2canvas(this.el, options)
      this.output = canvas.toDataURL()
      this.el.classList.add('hidden')
      this.loading = false
    },
    exit() {
      this.$store.dispatch('setShare', null)
      this.$store.dispatch('setShowShare', false)
    },
  },
}
</script>
